import httpClient from "@plugins/http";
import { ApiResponse } from "@apis/api.ts";
import {
  Notebook,
  NotebookStructure,
  NotebookAnchor,
  AnnotationLinkedNotebookInfo,
  NotebookRecentModel,
  NotebookPage,
  NotebookPageNote,
} from "@modules/notebook-editor/notebook-editor-types.ts";

const fetchNotebook = async (uuid: string): Promise<ApiResponse<Notebook>> => {
  return await httpClient.get(`/apis/notebook/get/${uuid}`);
};

const updateNotebook = async (notebook: Notebook): Promise<ApiResponse<Notebook>> => {
  return await httpClient.post(`/apis/notebook/update/${notebook.uuid}`, notebook);
};

const deleteNotebook = async (uuid: string): Promise<ApiResponse<Notebook>> => {
  return await httpClient.post(`/apis/notebook/delete/${uuid}`);
};

const fetchNotebookPages = async (uuid: string): Promise<ApiResponse<NotebookPage[]>> => {
  return await httpClient.get(`/apis/notebook/get/pages/${uuid}`);
};

const fetchNotebookNotes = async (
  uuid: string,
): Promise<ApiResponse<Record<number, NotebookPageNote[]>>> => {
  return await httpClient.get(`/apis/notebook/get/notes/${uuid}`);
};

const fetchNotebookStructure = async (uuid: string): Promise<ApiResponse<NotebookStructure>> => {
  return await httpClient.get(`/apis/notebook/structure/${uuid}`);
};

const fetchNotebookAnchor = async (uuid: string): Promise<ApiResponse<NotebookAnchor[]>> => {
  return await httpClient.get(`/apis/notebook/anchor/${uuid}`);
};

const fetchMostRecentNotebooks = async (): Promise<ApiResponse<NotebookRecentModel[]>> => {
  return await httpClient.get("/apis/notebook/list/most-recent");
};

const fetchAnnotationLinkedNotebooks = async (
  annotationId: number,
): Promise<ApiResponse<AnnotationLinkedNotebookInfo[]>> => {
  const data = new URLSearchParams();
  data.append("annotationId", annotationId.toString());
  return await httpClient.get(`/apis/notebook/list/annotation-linked?${data}`);
};

export default {
  fetchNotebook,
  updateNotebook,
  deleteNotebook,
  fetchNotebookPages,
  fetchNotebookNotes,
  fetchNotebookStructure,
  fetchNotebookAnchor, //dynamic link
  fetchMostRecentNotebooks,
  fetchAnnotationLinkedNotebooks,
};
